module.exports = __webpack_public_path__ + "img/closeMenu.0befdf49.png";